import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";

const NewsCard = ({ article }) => {
  const categoryLabels = {
    landlord_tips: "Landlord Tips",
    tenant_advice: "Tenant Advice",
    market_insights: "Market Insights",
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  return (
    <Card className="overflow-hidden border-slate-200 hover:border-navy/20 transition-all duration-300 h-full" data-testid={`news-card-${article.slug}`}>
      <Link to={`/news/${article.slug}`}>
        <div className="img-zoom">
          <img
            src={article.image_url || "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800"}
            alt={article.title}
            className="w-full h-48 object-cover"
          />
        </div>
        <CardContent className="p-6">
          <Badge variant="secondary" className="mb-3 bg-navy/5 text-navy">
            {categoryLabels[article.category] || article.category}
          </Badge>
          <h3 className="font-heading font-semibold text-lg text-navy mb-3 line-clamp-2 hover:text-gold transition-colors">
            {article.title}
          </h3>
          <p className="text-slate-600 text-sm mb-4 line-clamp-3">
            {article.excerpt}
          </p>
          <div className="flex items-center gap-2 text-slate-500 text-sm">
            <Calendar className="w-4 h-4" />
            <span>{formatDate(article.created_at)}</span>
          </div>
        </CardContent>
      </Link>
    </Card>
  );
};

export default NewsCard;
